import { Button, Link as LinkH, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import formatter from 'helpers/formatter';
const styles = {
  button: {
    color: '#FFF',
    '&:hover': {
      color: '#20aaf5'
    }
  },
  link: {
    textDecoration: 'inherit',
    '&:hover': {
      textDecoration: 'inherit'
    }
  }
};

function Items() {
  // const account = useSelector(state => state.account);
  const user = useSelector((state: any) => state.account.user);
  const country: any = formatter.getCountry();
  return (
    <>
      <Box hidden={user.role === 'not_role'}>
        {/* despues cambiar componente a Link */}
        <LinkH href="/transactions2" sx={styles.link}>
          <Button size="small" sx={styles.button}>
            Transacciones
          </Button>
        </LinkH>
        {user.permissions.includes('show_bi_section') && (
          <Link to={'/reporteria'} style={styles.link}>
            <Button size="small" sx={styles.button}>
              Reporteria
            </Button>
          </Link>
        )}
        {user.permissions.includes('access_to_reports') && (
          <Link to={'/reports'} style={styles.link}>
            <Button size="small" sx={styles.button}>
              Informes
            </Button>
          </Link>
        )}
        {(['evaluation_supervisor_rebuyer', 'rebuyer_administrator', 'rebuyer'].includes(user.role)) && country === 'cl'  && (
          <a href={"https://autosafe.cl/empresas"} style={styles.link} target="_blank" rel="noopener noreferrer">
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <Button size="small" sx={styles.button}>
                Transferencias
              </Button>

              <Box
                sx={{
                  position: 'absolute',
                  top: -8,
                  right: -8,
                  backgroundColor: '#EF4444',
                  color: '#FFFFFF',
                  fontSize: '0.625rem',
                  fontWeight: 'bold',
                  padding: '2px 6px',
                  borderRadius: '12px',
                  lineHeight: 1,
                  zIndex: 1,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}
              >
                ¡Nuevo!
              </Box>
            </Box>
          </a>
        )}
      </Box>
    </>
  );
}

export default Items;
